<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml">
  <div class="m-h-10 p-v-10 p-h-10" style="background-color: #F9F9F9">
    <div class="w-full flex m-b-10">
      <slot name="leftBtn"></slot>
      <class-choose-widget :gutter="10" :srcType="10" @dataChange="onClassGroupChange" leftPlaceholder="视频分类"
                           rightPlaceholder="视频分组" style="width: 240px;">
      </class-choose-widget>
      <Input class="m-l-15" placeholder="视频名称" style="width: 160px" v-model="searchName"/>
      <Button @click="onSearchClick" class="m-l-15">搜索</Button>
      <div class="flex-1 flex-shrink-1 j-end"></div>
      <Button @click.stop=" onVideoUpload" class="" type="primary">本地上传</Button>
    </div>

    <!--列表数据-->
    <div class=" scrollbar  o-y-auto  p-t-10" style="height: 480px;">
      <div class="list-container" style="width:100%;top: 60px;overflow: hidden">
        <div :class="{ 'item-selected':isSelect(item),'item-normal':!isSelect(item), 'm-r-12':index %5!==4}"
             :key="index" @click="itemClick(item,index)" class=" m-b-10 item b-2 bg-white"
             v-for="(item,index) in dataList">
          <div class="w-full h-full" style="position: relative">
            <div class="w-full h-120" style="position: relative">
              <div class="w-full h-120 o-hidden flex a-center j-center">
                <img :src="(!item.coverImgUrl)?require('../../assets/common/ic_wutu@2x.png'):item.coverImgUrl"
                     style="width: 100%;min-height: 120px"/>
              </div>
              <!--鼠标悬停编辑-->
              <div class="flex a-end j-center  w-full h-full  item-editable"
                   style="position: absolute;bottom: 0;left: 0;right: 0;height: 30px;background-color: #0000004d">
                <div @click.stop="itemEdit(item,index)" class="w-24 h-24 b-round flex a-center j-center"
                     style="cursor: pointer;">
                  <img class="w-20 h-20" src="../../assets/common/ic-link@2x.png" v-clipboard:copy="item.linkurl"
                       v-clipboard:error="copyOnError" v-clipboard:success="copy"/>
                </div>
              </div>
              <!--鼠标悬停三角-->
              <div class="triangle" style="position: absolute;top: 0;right: 0;" v-if="isSelect(item)">
              </div>
              <!--鼠标悬停对号-->
              <img class="w-16 h-16" src="../../assets/common/ic-right@2x.png"
                   style="position: absolute;top: 0;right: 0;" v-if="isSelect(item)">
            </div>
            <span class="lin2 m-h-5 m-t-12">{{ item.title }}</span>
          </div>
        </div>
      </div>
    </div>
    <Page :current="tablePage.currentPage" :page-size="tablePage.pageSize" :total="tablePage.total"
          @on-change="onPageChange" class="m-t-10  w-full" show-total/>
    <Modal @on-visible-change="uploadModalVisibleChange" class="modal-setting" class-name="vertical-center-modal"
           footer-hide v-model="showvideoedit" width="880">
      <p class="text-center" slot="header">
        <span class="bold">上传视频</span>
      </p>
      <div class="w-full p-l-20">
        <Row :gutter="25" class="w-full">
          <Col span="12">
            <video-edit-test :videoInfix="videoInfix" :vidupload="false" ref="videoEditTest"/>
          </Col>
          <Col span="12">
            <div @click="onPicChoose" style="position: relative;left: 0;top: 0">
              <div class="flex-column a-center j-center w-full"
                   style="height: 255px;background-color: #F6F9FF;cursor: pointer">
                <img alt="" src="../../assets/common/ic_upload_picture@2x.png" style="width: 64px;height: 64px">
                <span class="m-t-5  color-66">上传视频封面</span>
              </div>
              <div class="w-full o-hidden flex a-center j-center"
                   style="position: absolute;height: 255px;left: 0;top: 0;background-color: #F6F9FF;"
                   v-if="imgUrl">
                <img :src="imgUrl" class="w-full" style="min-height: 100%"/>
              </div>
            </div>
          </Col>
        </Row>
        <div class="flex a-center j-center p-v-10 m-t-20">
          <Button @click="uploadModalCancel()" class="m-r-20" style="width: 100px">取消</Button>
          <Button @click="uploadModalOk()" class="m-r-10" style="width: 100px" type="primary">确认</Button>
        </div>
      </div>
    </Modal>
    <pic-choice-widget :on-ok="picChoiceOk" ref="picChoiceWidget"/>

  </div>
</template>

<script>
import ClassChooseWidget from '../common/ClassChooseWidget'
import PicChoiceWidget from '../common/chiose/PicChoiceWidget'
import VideoEditTest from '../common/VideoEditTest'
import {mapActions} from 'vuex'

export default {
  name: 'VideoLibWidget',
  components: {VideoEditTest, PicChoiceWidget, ClassChooseWidget},
  props: {
    selectObj: {
      type: Object,
      default: () => {
        return {
          maps: new Map(),
          mapLength: 0
        }
      }
    },
    multiple: {
      type: Boolean,
      default: false
    },
    videoInfix: {
      type: String,
      default: 'common/desc/'
    }
  },
  data () {
    return {
      objChange: {                               //分类分组帅选
        classId: 0,
        groupId: 0,
        linkurl: ''
      },
      tablePage: {                               //表格分页
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },

      //搜索名称
      searchName: '',

      //显示隐藏
      modalShowHide: false,
      // 上传弹框显示隐藏
      showvideoedit: false,

      // 列表数据
      dataList: [],
      imgUrl: '',
      videoInfo: {  //视频信息
        id: 0,            //这条视频在后台库的Id
        videoAliVid: '',  //阿里云路径
        localUrl: '',     //本地路径
        videoUrl: '',     //Oss视频路径
        videoTitle: '',   //视频标题
        imgUrl: '',       //视频封面
        videoTime: '',    //视频时长
        videoSize: '',    //视频大小
        videoDesc: ''     //视频描述
      },

      dCGInfo: {
        classId: 0,
        groupId: 0
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.tablePage.currentPage = 1
      this.getVideoListData()
      this.getDefaultCGInfo()
    },
    async getDefaultCGInfo () {
      let params = {
        type: 10
      }
      let result = await this.getCategoryLists(params)
      if (result.code === 0) {
        let item = result.data.find(e => {
          return e.isDefault === 1
        })
        if (item && item.id) {
          this.dCGInfo.classId = item.id
          let p = {
            categoryId: item.id,
            type: 10
          }
          let res = await this.getGroupLists(p)
          if (res.code === 0) {
            let itemInfo = res.data.find(e => {
              return e.isDefault === 1
            })
            if (itemInfo && itemInfo.id) {
              this.dCGInfo.groupId = itemInfo.id
            }
          }
        }
      }
    },
    /**
     * 获取视频库列表
     * */
    getVideoListData () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      if (this.searchName) {
        params.title = this.searchName
      }
      if (this.objChange && this.objChange.classId) {
        params.categoryId = this.objChange.classId
      }
      if (this.objChange && this.objChange.groupId) {
        params.groupId = this.objChange.groupId
      }
      this.getVideoList(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
            child.videoDuration = this.formatSeconds(child.videoLength)
            child.linkurl = child.jumpLink ? child.jumpLink.link || '' : ''
            return child
          })
          this.tablePage.total = res.data.total
        }
      })
    },

    ok () {
      if (this.onOk) {
        let data = []
        this.selectObj.maps.forEach((value, key) => {
          data.push({
            videoTitle: value.title,
            coverUrl: value.coverImgUrl || '',
            videoUrl: value.url,
            sourceUrl: value.sourceUrl,
            linkurl: value.linkurl,
          })
        })
        this.onOk(data)
      }
      this.hide()
    },
    cancel () {
      if (this.onCancel) {
        this.onCancel()
      }
      this.modalShowHide = false
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    copyOnError (e) {
      this.$Message.info('复制失败')
    },
    itemClick (item, i) {
      let id = item.videoId
      if (this.multiple) {
        if (this.selectObj.maps.has(id)) {
          this.selectObj.maps.delete(id)
        } else {
          this.selectObj.maps.set(id, item)
        }
      } else {
        this.selectObj.maps.clear()
        this.selectObj.mapLength = 0
        this.selectObj.maps.set(id, item)
      }
      this.selectObj.mapLength = this.selectObj.maps.size
    },
    isSelect (item) {
      let id = item.videoId
      if (this.selectObj.mapLength && this.selectObj.maps.has(id)) {
        return true
      } else {
        return false
      }
    },
    show () {
      this.modalShowHide = true
    },
    hide () {
      this.modalShowHide = false
    },
    isShowing () {
      return this.modalShowHide
    },
    onVisibleChange (show) {
      if (show) {//弹框显示
        this.tablePage.currentPage = 1
        this.getVideoListData()
      } else {            //弹框隐藏
        this.clearData()
      }
    },
    clearData () {      //清除数据
      this.tablePage.currentPage = 1
      this.dataList = []
      this.searchName = ''
      this.selectObj.maps.clear()
      this.selectObj.mapLength = this.selectObj.maps.size
    },
    uploadModalVisibleChange (status) {
      if (status) {
        console.log('上传弹框可见')
      } else {
        console.log('上传弹框消失')

        this.$refs.videoEditTest.videoinfos = {  //视频信息
          id: 0,            //这条视频在后台库的Id
          videoAliVid: '',  //阿里云路径
          localUrl: '',     //本地路径
          videoUrl: '',     //Oss视频路径
          videoTitle: '',   //视频标题
          imgUrl: '',       //视频封面
          videoTime: '',    //视频时长
          videoSize: '',    //视频大小
          videoDesc: ''     //视频描述
        }
        this.$refs.videoEditTest.videoprewinfo = {       //预览参数
          videoAliVid: '',
          videoUrl: '',
          coverUrl: '',
          videoTitle: ''
        }
      }
    },
    uploadModalOk () {
      let videoinfos = this.$refs.videoEditTest.getVideoInfo()
      if (!videoinfos.videoUrl) {
        return
      }
      if (!videoinfos.videoTitle) {
        return
      }
      let categoryId = this.objChange.classId || 0
      let groupId = this.objChange.groupId || 0
      if (this.objChange.classId < 1 && this.dCGInfo.classId) {
        categoryId = this.dCGInfo.classId || 0
        groupId = this.dCGInfo.groupId || 0
      }
      let params = {
        groupId: groupId,
        categoryId: categoryId,
        coverImgUrl: this.imgUrl || '',
        length: videoinfos.videoTime || 0,
        url: videoinfos.videoUrl || '',
        title: videoinfos.videoTitle || '',
        desc: '',
        jumpLink: '',
        width: videoinfos.width || 0,
        height: videoinfos.height || 0
      }
      this.addVideo(params).then(res => {
        if (res.code === 0) {
          this.tablePage.currentPage = 1
          this.getVideoListData()
          this.showvideoedit = false
        }
        if (res.msg) {
          this.$Message.info(res.msg)
        }
      })
    },
    uploadModalCancel () {
      this.showvideoedit = false
    },

    /**
     * 输入搜索筛选
     */
    onSearchClick () {
      this.tablePage.currentPage = 1
      this.getVideoListData()
    },
    onVideoUpload () {
      this.imgUrl = ''
      this.showvideoedit = true
    },
    onClassGroupChange (e) {
      this.objChange = e
      this.tablePage.currentPage = 1
      this.getVideoListData()
    },
    onPageChange (page) {
      this.pageNum = page
      this.getVideoListData()
    },

    formatSeconds (value) {
      var secondTime = parseInt(value)// 秒
      var minuteTime = 0// 分
      var hourTime = 0// 小时
      if (secondTime > 60) {//如果秒数大于60，将秒数转换成整数
        //获取分钟，除以60取整数，得到整数分钟
        minuteTime = parseInt(secondTime / 60)
        //获取秒数，秒数取佘，得到整数秒数
        secondTime = parseInt(secondTime % 60)
        //如果分钟大于60，将分钟转换成小时
        if (minuteTime > 60) {
          //获取小时，获取分钟除以60，得到整数小时
          hourTime = parseInt(minuteTime / 60)
          //获取小时后取佘的分，获取分钟除以60取佘的分
          minuteTime = parseInt(minuteTime % 60)
        }
      }
      var result = '' + parseInt(secondTime) + '秒'

      if (minuteTime > 0) {
        result = '' + parseInt(minuteTime) + '分' + result
      }
      if (hourTime > 0) {
        result = '' + parseInt(hourTime) + '小时' + result
      }
      return result
    },
    onPicChoose () {
      this.$refs.picChoiceWidget.show()
    },
    picChoiceOk (data) {
      if (data && data.length) {
        this.imgUrl = data[0].url
      }
    },
    ...mapActions([
      'getVideoList',
      'delVideo',
      'addVideo',
      'getCategoryLists',
      'getGroupLists'
    ])
  }
}
</script>

<style lang="scss" scoped>

  .list-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    overflow-x: hidden;
  }

  .item {
    width: 140px;
    height: 170px;
    flex-direction: row;
    margin-bottom: 10px;
  }

  .item-selected {
    //border-color: #0EA4FB;
    //border-width: 2px;
    border: 2px solid #0EA4FB;
  }

  .item-normal {
    //border-color: #0EA4FB;
    //border-width: 2px;
    border: 2px solid white;
  }

  .item-editable {
    display: none;
  }

  .item:hover .item-editable {
    display: flex;
  }

  .lin2 {
    color: #333;
    max-width: 600px;
    font-size: 13px;
    line-height: 20px;
    //height: 40px;
    //margin-top: 6px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
    -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
    -webkit-line-clamp: 1; /** 显示的行数 **/
    overflow: hidden; /** 隐藏超出的内容 **/
  }


  .triangle {
    width: 0;
    height: 0;
    border-color: transparent #0F8CFB;
    border-width: 0 25px 25px 0;
    border-style: solid;
  }

  .modal-product-link ::v-deep {
    .ivu-modal-body {
      padding: 0;
      display: flex;
      justify-content: center;
    }

    //标题下横线
    .ivu-modal-header {
      border-bottom: none;
    }

    //确认取消按钮上面红线
    .ivu-modal-footer {
      border-top: none;
    }
  }

  //扩大商品链接按钮点击范围
  .icon-link {
    padding: 7px;
    margin: 0;
  }

  //扩大商品链接按钮点击范围
  #input-product ::v-deep {
    .ivu-input-group-append {
      padding: 0;
    }
  }
</style>
